import React from "react"
import styled, {css} from "styled-components"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Body} from "@irati/ui/src/Typography"

const helpItems = [
  "FAQs",
  "Terms and Conditions",
  "Impact on employment package",
  "Payroll Pay® - How it works",
  "Government Pension Scheme Calculator"
]

export const HelpContent = () => {
  return (
    <Container>
      {helpItems.map((item, index) => (
        <ListItem key={index}>
          <Body>{item}</Body>
          <Icon icon={IconTypes.chevronRight} size={24} />
        </ListItem>
      ))}
    </Container>
  )
}

const Container = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.two};
  `}
`

const ListItem = styled.div`
  ${({theme}) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing.two} 0;
    cursor: pointer;
  `}
`
